<div class="content">
    <div class="content">
     <div class="container-fluid">
      <div class="row">
       <div class="col-lg-12 col-md-12 col-sm-12 common_title">
       <h2>CREATE - ACCESS MANAGEMENT</h2>
       <p>Lorem Ipsum Dolor Sit Amet, Consetetur Sadipscing Elitr, Sed Diam Nonumy</p>
       <a href="#" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
        Back
       </a>
       </div>
      </div>
       <form class="row">
<div class="col-lg-12 col-md-12 col-sm-12 mt-3">
 <table class="table table-striped">
    <tbody>
       <tr>
          <td>
             <div class="form-check">
                <label class="form-check-label">
                   <input class="form-check-input" type="checkbox" value=""> Enable raw data view and editing
                   <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam</p>
                   <span class="form-check-sign">
                   <span class="check"></span>
                   </span>
                </label>
             </div>
          </td>
       </tr>
       <tr>
          <td>
             <div class="form-check">
                <label class="form-check-label">
                   <input class="form-check-input" type="checkbox" value=""> Enable processing data view and editing
                   <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam</p>
                   <span class="form-check-sign">
                   <span class="check"></span>
                   </span>
                </label>
             </div>
          </td>
       </tr>
       <tr>
          <td>
             <div class="form-check">
                <label class="form-check-label">
                   <input class="form-check-input" type="checkbox" value=""> Enable all farms data viewing and editing
                   <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam</p>
                   <span class="form-check-sign">
                   <span class="check"></span>
                   </span>
                </label>
             </div>
          </td>
       </tr>
       <tr>
          <td>
             <div class="form-check">
                <label class="form-check-label">
                   <input class="form-check-input" type="checkbox" value=""> Lorem Ipsum Dolor
                   <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam</p>
                   <span class="form-check-sign">
                   <span class="check"></span>
                   </span>
                </label>
             </div>
          </td>
       </tr>
       <tr>
          <td>
             <div class="form-check">
                <label class="form-check-label">
                   <input class="form-check-input" type="checkbox" value=""> Lorem Ipsum Dolor
                   <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam</p>
                   <span class="form-check-sign">
                   <span class="check"></span>
                   </span>
                </label>
             </div>
          </td>
       </tr>
    </tbody>
 </table>
</div>
<div class="col-lg-12 col-md-12 col-sm-12 text-center">
 <button type="submit" (click)="accessmanagement()" class="btn btn-fill btn-primary mb-3">
    Submit
    <div class="ripple-container"></div>
 </button>
 <br>
 <button type="submit" class="btn btn-fill btn-default">
    Cancel
    <div class="ripple-container"></div>
 </button>
</div>
</form>
     </div>
   </div>
 </div>
